import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/academic-group`;

// * Route configuration object for academicGroup-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const academicGroupRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:academicGroupId`,
  edit: `${baseRoute}/edit/:academicGroupId`,
} as const;

// ! these are breadcrumbs translation not page title
export const academicGroupRouteTranslation: IRouteTranslation<
  typeof academicGroupRoutesObj
> = {
  list: "academicGroupsList",
  create: "addAcademicGroup",
  edit: "editAcademicGroup",
  view: "viewAcademicGroup",
};

// * Extracts the route parameters for the academicGroup route configuration.
export type IAcademicGroupRouteParams = IExtractRouteParamMap<
  typeof academicGroupRoutesObj
>;

// * Path functions for the academicGroup routes.
export const academicGroupPath = createPaths<
  typeof academicGroupRoutesObj,
  IAcademicGroupRouteParams
>(academicGroupRoutesObj);

// * Breadcrumbs {translation and route} for the academicGroup routes
export const academicGroupBreadcrumbs = createBreadcrumbObject<
  typeof academicGroupRoutesObj
>(academicGroupRoutesObj, academicGroupRouteTranslation);
rebase(academicGroupBreadcrumbs, "list");
